import { FileExcelOutlined } from "@ant-design/icons";
import "./index.css";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { BiRightArrowAlt, BiSolidPurchaseTag } from "react-icons/bi";

const purchaseItemColumns = [
  {
    columnName: "Price/ Item(₹)",
    key: "Price",
    value: false,
  },
  {
    columnName: "Quantity",
    key: "Qty",
    value: false,
  },
  {
    columnName: "Custom Column",
    key: "CustomColumn",
    value: false,
  },
  {
    columnName: "Travel",
    key: "Travel",
    value: false,
  },
  {
    columnName: "Batch no.",
    key: "batch",
    value: false,
  },
  {
    columnName: "Exp. Date",
    key: "expiryDate",
    value: false,
  },
  {
    columnName: "Mfg Date",
    key: "mfgDate",
    value: false,
  },
];

const createItemsData = [
  {
    columnName: "Item Name",
    key: "itemName",
    value: false,
  },
  {
    columnName: "Item Code",
    key: "itemCode",
    value: false,
  },
  {
    columnName: "Sales Price",
    key: "salesPrice",
    value: false,
  },
  {
    columnName: "Purchase Price",
    key: "purchasePrice",
    value: false,
  },
  {
    columnName: "Current Stock",
    key: "currentStock",
    value: false,
  },
  {
    columnName: "Quantity",
    key: "quantity",
    value: false,
  },
];

const createItemTableData = [
  {
    itemName: "Country Eggs",
    itemCode: "-",
    salesPrice: "-",
    purchasePrice: "-",
    currentStock: "0 pcs",
    quantity: "",
  },
  {
    itemName: "Kadaknath Eggs",
    itemCode: "-",
    salesPrice: "₹ 125",
    purchasePrice: "₹ 100",
    currentStock: "-1 pcs",
    quantity: "",
  },
  {
    itemName: "Fish",
    itemCode: "-",
    salesPrice: "₹ 125",
    purchasePrice: "₹ 100",
    currentStock: "-1 pcs",
    quantity: "",
  },
  {
    itemName: "Labster",
    itemCode: "-",
    salesPrice: "",
    purchasePrice: "",
    currentStock: "1 pcs",
    quantity: "",
  },
];

const TableData = [
  {
    date: "12 Aug 2024",
    paymentNumber: "4",
    partyName: "faisal",
    amount: "₹ 900",
  },
  {
    date: "12 Aug 2024",
    paymentNumber: "6",
    partyName: "karthick",
    amount: "₹ 300",
  },
];

const paymentFaqList = [
  {
    key: "1",
    label: "Do I need to link Invoices to Payments?",
    children: (
      <p className="text-[12px]">
        To create Payments, it is not mandatory to link Invoices. But doing so
        would benefit you greatly as you will be able to mark those invoices as
        paid and track unpaid invoices accurately.
      </p>
    ),
  },
  {
    key: "2",
    label: "Can I link multiple Invoices to 1 Payment?",
    children: (
      <p className="text-[12px]">
        Yes, you can link 1 payment to multiple invoices. For example, 1 payment
        of Rs 10,000 was linked to 3 invoices of 3,000, 4,000 and 5,000. In this
        case, the last invoice of 5,000 will be marked as partially paid with an
        outstanding of Rs 2,000 [5,000 - 3,000 left from the 10,000].
      </p>
    ),
  },
];

const purchaseHeaders = [
  {
    label: "Total Purchases",
    key: "1",
    icon: <BiSolidPurchaseTag size={16} />,
    amount: "₹ 1,465",
    color: "blue",
  },
  {
    label: "Paid",
    key: "2",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "₹ 336.5",
    color: "green",
  },
  {
    label: "Unpaid",
    key: "3",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "₹ 1,150",
    color: "red",
  },
];
const items = [
  {
    label: <a href="/purchase">GSTR</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/purchase">Daybook</a>,
    key: "2",
  },
];
const balaceCollectOptions = [
  {
    label: "To Collect",
    value: "toCollect",
  },
  {
    label: "To Pay",
    value: "toPay",
  },
];

const partyTypeOptions = [
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Supplier",
    value: "supplier",
  },
];
const bulkActions = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[45px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex text-[14px] font-semibold">
        <FileExcelOutlined className="mr-2" /> Bulk Add Parties
      </p>
      <p className="mt-1 text-[12px]">
        Quickly add all your Parties with Excel
      </p>
    </div>
    <BiRightArrowAlt size={24} />
  </div>
);
export {
  items,
  purchaseHeaders,
  balaceCollectOptions,
  TableData,
  partyTypeOptions,
  bulkActions,
  purchaseItemColumns,
  createItemsData,
  createItemTableData,
  paymentFaqList,
};
